import { encode as base64_encode } from "base-64";
import config from "../config";

import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";

class PointofInterest {
  loading = false;
  total = 0;
  poiList = [];
  poiTypeArr = [];
  photoFromDb = {};
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      loading: observable,
      total: observable,
      poiList: observable,
      poiTypeArr: observable,
      photoFromDb: observable,
      loadData: action,
      deleteRecord: action,
      addData: action,
      poiTypeData: action,
      getPOIData: action,
      setPhotoFromDb: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ companyId, offset, limit }) {
    this.loading = true;
    var postData = {
      companyId: companyId,
      offset: offset,
      limit: limit,
    };

    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .get(config.NodeUrl + "/pointOfInterest/getGridPoi", {
        params: postData,
      });

    this.poiList = response?.data?.data?.poidata;
    this.total = parseInt(response?.data?.data?.TotalCount);

    this.loading = false;
  }

  async addData(poiDetails) {
    var response = await postApi
      .getClient()
      .post(config.NodeUrl + "/pointOfInterest/createOrUpdate", poiDetails);
    console.log(response);
    return response.data;
  }

  async getPOIData({ Id, companyId }) {
    var postData = {
      pId: Id,
      companyId: companyId,
      limit: 1,
      offset: 0,
    };
    // console.log(postData)

    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=poidata&a=getGridPoi", "postData=" + base64Input);

    // const singleRow = response?.data?.data?.poidata[0];

    // if (singleRow.path) {
    //   const fileList = [
    //     {
    //       name: singleRow.path,
    //       status: "success",
    //       url: config.fleetURL + singleRow.path,
    //     },
    //   ];

    //   this.setPhotoFromDb(fileList);
    // }
    // return singleRow;

    var response = await postApi
      .getClient()
      .get(config.NodeUrl + "/pointOfInterest/getGridPoi", {
        params: postData,
      });

    const singleRow = response?.data?.data?.poidata[0];
    const fileName = singleRow.path.split("/").pop();

    if (singleRow.path) {
      const fileList = [
        {
          name: fileName,
          status: "success",
          url: config.fleetURL + singleRow.path,
        },
      ];

      this.setPhotoFromDb(fileList);
    }
    return singleRow;
  }

  async setPhotoFromDb(photo) {
    console.log(photo);
    this.photoFromDb = { fileList: photo };
  }

  async poiTypeData() {
    var response = await postApi
      .getClient()
      .get(config.NodeUrl + "/pointOfInterest/getPoiTypes");
    this.poiTypeArr = response.data.data;
  }

  async deleteRecord({ id }) {
    var response = await postApi
      .getClient()
      .delete(
        `https://dolphin.trackeazy.com/api/pointOfInterest/deletePoi/${id}`
      );
    return response;
  }
}

export default PointofInterest;
